export default __webpack_public_path__ + "static/media/tasks-solid.49f93031.svg";